import React, {Component} from 'react';
import {connect} from 'react-redux';
import {keyBy, isEmpty} from 'lodash';
import {Table, Input, Select, Button} from 'semantic-ui-react';
import {getTotalColumn, validateUnique} from '../../../utils';
import {Actions} from '../../../../common/actions';
import Loader from '../../../../common/components/loader';

const FormSubContract = (props) => {
  const {id, numInvoice, observation, handleChangeSelect,
    total, handleChange, handleAddItem, subcontractOptions, subcontractObject} = props;
  const validateBtn = numInvoice === '' || total <= 0;

  return (
    <Table.Row>
      <Table.Cell>
        <Select
          options={subcontractOptions}
          className="twc-works-input"
          placeholder='No.Operación'
          value={id}
          onChange={(e, {value}) => handleChangeSelect('id', value)} />
      </Table.Cell>
      <Table.Cell>
        <Input
          className="twc-works-input"
          placeholder='Descripción código'
          value={isEmpty(subcontractObject) ? '' : subcontractObject[id].description}
        />
      </Table.Cell>
      <Table.Cell>
        <Input
          className="twc-works-input"
          placeholder='No. de factura'
          value={numInvoice}
          onChange={(e, {value}) => handleChange('numInvoice', value)}

        />
      </Table.Cell>
      <Table.Cell>
        <Input
          className="twc-works-input"
          placeholder={'Descripción Usuario'}
          value={observation}
          onChange={(e, {value}) => handleChange('observation', value)}
        />
      </Table.Cell>
      <Table.Cell>
        <Input
          className="twc-works-input"
          placeholder={'Total'}
          value={total}
          type="number"
          min="0"
          onChange={(e, {value}) => handleChange('total', value)}
        />
      </Table.Cell>
      <Table.Cell>
        <Button
          disabled={validateBtn}
          onClick={() => handleAddItem()}
          size='mini'
          color="green">
            Agregar
        </Button>
      </Table.Cell>
    </Table.Row>
  );
};

const DisplayData = ({item, handleRemoveItem, idx, subcontractObject, disabledBtns}) => {
  const {id, numInvoice, observation, total} = item;
  return (
    <Table.Row>
      <Table.Cell>
        {id}
      </Table.Cell>
      <Table.Cell>
        {isEmpty(subcontractObject) ? '' : subcontractObject[id].description}
      </Table.Cell>
      <Table.Cell>
        {numInvoice}
      </Table.Cell>
      <Table.Cell>
        {observation}
      </Table.Cell>
      <Table.Cell>
        $ {total}
      </Table.Cell>
      <Table.Cell>
        <Button
          disabled={disabledBtns}
          onClick={() => handleRemoveItem(idx)}
          size='mini'
          color="red">
            Eliminar
        </Button>
      </Table.Cell>
    </Table.Row>
  );
};

const initialState = {
  'id': 'AC',
  'numInvoice': '',
  'observation': '',
  'total': 0.0,
};

class Subcontract extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...initialState,
    };
  }

  componentDidMount() {
    this.props.getWarrantySubcontractList();
  }

  handleAddItem = () => {
    const {handleChangeForm} = this.props;
    const {id, numInvoice, observation, total} = this.state;
    const newSunContracts = [...this.props.subcontracts];
    const item = {
      id,
      numInvoice,
      observation,
      'total': +total,
    };

    if (validateUnique(newSunContracts, 'id', id)) {
      newSunContracts.push(item);
      this.setState({
        ...initialState,
      }, () => {
        handleChangeForm('subcontracts', newSunContracts);
      });
    } else {
      this.props.addMessageBoxError(`El item ${id} ya se encuentra en la lista`);
    }
  }

  handleRemoveItem = (id) => {
    const {handleChangeForm} = this.props;
    const subcontracts = [...this.props.subcontracts].filter((item, idx) => idx !== id);
    handleChangeForm('subcontracts', subcontracts);
  }

  handleChange = (field, value) => {
    this.setState({
      [field]: value,
    });
  }

  render() {
    const {loading, subcontracts, subcontractOptions, subcontractObject, disabledBtns} = this.props;
    
    if (loading) {
      return <div className='twc-loader-subcontracts' >
        <Loader/>
      </div>;
    }

    return (
      <div>
        <div className="warranty-container-table">
          <Table celled>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Código</Table.HeaderCell>
                <Table.HeaderCell>Descripción</Table.HeaderCell>
                <Table.HeaderCell>No. de factura</Table.HeaderCell>
                <Table.HeaderCell>Descripción Usuario</Table.HeaderCell>
                <Table.HeaderCell>Valor</Table.HeaderCell>
                <Table.HeaderCell></Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {!disabledBtns && <FormSubContract
                subcontractObject={subcontractObject}
                subcontractOptions={subcontractOptions}
                handleChange={this.handleChange}
                handleChangeSelect={this.handleChange}
                {...this.state}
                handleAddItem={this.handleAddItem}
                loading={loading}
              />
              }

              {subcontracts.map((subcontract, idx) => (
                <DisplayData
                  disabledBtns={disabledBtns}
                  key={idx}
                  item={subcontract}
                  idx={idx}
                  subcontractObject={subcontractObject}
                  handleRemoveItem={this.handleRemoveItem} />
              ))}
              <Table.Row className="warranty-table-footer">
                <Table.Cell/>
                <Table.Cell/>
                <Table.Cell/>
                <Table.Cell>SUBTOTAL</Table.Cell>
                <Table.Cell>$ {getTotalColumn(subcontracts, 'total')}</Table.Cell>
                <Table.Cell> </Table.Cell>
              </Table.Row>
            </Table.Body>

          </Table>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const subcontractOptions = state.warrantiesCategories.subcontractList.map((item) => ({
    'text': item.type,
    'value': item.type,
    'key': item.type,
  }));

  return {
    'permissions': state.session.permissions,
    'loading': state.warrantiesCategories.loading,
    subcontractOptions,
    'subcontractObject': keyBy(state.warrantiesCategories.subcontractList, 'type'),
  };
};

const {getWarrantySubcontractList, addMessageBoxError} = Actions;

export default connect(mapStateToProps, {
  getWarrantySubcontractList,
  addMessageBoxError,
})(Subcontract);
